import { Box } from '@mantine/core';
import PlayerDrawing from './PlayerDrawing';

export default function DrawingList({
  drawings,
  size = 200,
  columns = 4,
  style,
}) {
  if (!drawings || drawings.length === 0) return null;

  return (
    <Box style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, ${size}px)`,
      columnGap: `${Math.round(size * 0.2)}px`,
      rowGap: `${Math.round(size * 0.4)}px`,
      justifyContent: 'center',
      ...style,
    }}>
      {drawings.map((drawing) => (
        <PlayerDrawing
          key={drawing.playerId}
          src={drawing.response}
          alt={`Drawing by ${drawing.playerName}`}
          playerName={drawing.playerName}
          size={size}
        />
      ))}
    </Box>
  );
}
